export const headerDataRH = {
    title: 'Ressources humaines',
    submodules: [
        createData(0, "Planification congé", "/me/leaves"),
        // createData(1, "Gestion de congé", "/hr/leaves"),
        createData(2, "Gestion du personnel", "/personnel"),
        createData(3, "Annuaire", "/annuaire"),
        createData(4, "Information sur la Famille", "/information_famille"),
        createData(5, "Historique solde", "/leaveBalanceSummary"),
        createData(6, "Pointage", "/timeTracking"),
        createData(7, "Pointage Manuel", "/timeTrackingprovisional"),
        createData(8, "Resultat évaluations", "/resultats"),
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}